/* eslint-disable max-len */
import styled from 'styled-components'
import Colors from '../../theme/colors'
import Fonts from '../../theme/fonts'

const buttonStyles = props => `
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  border: none;
  Padding: 12px 16px 12px 16px;
  font-family: ${Fonts.fontFamilies.Inter};
  font-size: ${Fonts.fontSizes.p16};
  line-height: 16px;
  min-width: 128px;
  outline: none;

  height: ${props.size === 'large' ? '48px' : '40px'};

  svg {
    margin-right: 0.5rem;
    height: 14px;
  }

  :disabled {
    background-color: ${Colors.Primary.GreyLight};
    color: ${Colors.Primary.Grey};
    cursor: not-allowed;

    svg {
      path {
        fill: ${Colors.Primary.Grey};
      }
    }
  }

  :not(:disabled):hover {
    cursor: pointer;
  }

  :focus {
    outline: none;
  }

  .circularProgress-root {
    height: 26px;
    width: 26px;
    margin-left: 13px;
    display: inline-block;
    animation: root-animation 1.4s linear infinite;
  }

  .circularProgress-svg {
    width: 26px;
    height: 26px;
  }

  .circularProgress-circle {
    stroke: currentColor;
    stroke-dasharray: 80px,200px;
    stroke-dashoffset: 0;
    animation: circle-animation 1.4s ease-in-out infinite;
  }

  @keyframes root-animation {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes circle-animation {
    0% {
      stroke-dasharray: 1px,200px;
      stroke-dashoffset: 0;
    }

    50% {
      stroke-dasharray: 100px,200px;
      stroke-dashoffset: -15px;
    }

    100% {
      stroke-dasharray: 100px,200px;
      stroke-dashoffset: -125px;
    }
  }

`

export const PrimaryYellow = styled.button`
  ${props => buttonStyles(props)}

  color: ${Colors.Primary.GreyText};
  background-color: ${Colors.Primary.yellow500};

  :not(:disabled):hover {
    background-color: ${Colors.Primary.yellow600};
  }
`

export const PrimaryBlack = styled.button`
  ${props => buttonStyles(props)}

  color: ${Colors.Primary.White};
  background-color: ${Colors.Primary.Black};

  :not(:disabled):hover {
    background-color: ${Colors.Primary.GreyDark};
  }

  svg {
    path {
      fill: ${Colors.Primary.White};
    }
  }
`

export const SecondaryButton = styled.button`
  ${props => buttonStyles(props)}

  background-color: ${Colors.Primary.White};
  border: 1px solid ${Colors.Primary.GreyTextLight};

  :hover {
    background-color: ${Colors.Primary.GreyWhite};
    color: ${Colors.Primary.GreyText};
  }

  :disabled {
    border-color: ${Colors.Primary.Grey};
    background-color: ${Colors.Primary.White};
    color: ${Colors.Primary.Grey};
  }
`

export const LinkButton = styled.button`
  ${props => buttonStyles(props)}

  background-color: rgba(0,0,0,0);
  border: none;
  padding: 12px 16px 12px 16px;
  font-family: ${Fonts.fontFamilies.Inter};
  font-size: ${Fonts.fontSizes.p16};
  line-height: 16px;
  text-underline-position: under;

  :hover {
    text-decoration-line: underline;
    -webkit-text-decoration-line: underline;
    text-decoration-thickness: 1px;
    -webkit-text-decoration-thickness: 1px;
    text-decoration-style: solid;
    -webkit-text-decoration-style: solid;
    text-decoration-color: ${Colors.Primary.GreyText};
    -webkit-text-decoration-color: ${Colors.Primary.GreyText};
  }

  :disabled {
    color: ${Colors.Primary.Grey};
    text-decoration-color: ${Colors.Primary.Grey};
    -webkit-text-decoration-color: ${Colors.Primary.Grey};
  }
`
